import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { api, authHeaders, fmtError } from "@/lib/api";
import { Input } from "@/components/admin/ui";

export function AutofillBar({ kind, form, setForm, linkKey = "href" }) {
  const [url, setUrl] = useState(form[linkKey] || "");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!url.trim()) return toast.error("Paste a link first");
    setBusy(true);
    try {
      const { data } = await axios.post(api("/api/admin/autofill"), { url: url.trim(), kind }, { headers: authHeaders() });
      const { readable, img, ...fields } = data;
      if (form.id && kind === "reel") delete fields.series;
      const clean = Object.fromEntries(Object.entries(fields).filter(([, v]) => v !== "" && v !== null && v !== undefined));
      setForm((f) => ({ ...f, ...clean, [linkKey]: url.trim(), ...(img && (kind === "reel" || !f.img) ? { img } : {}) }));
      if (readable) toast.success("Filled in from the link. Check it, then save.");
      else toast.warning("Couldn't open the link's content, so these are best guesses from the URL. Please check them.");
    } catch (e) {
      toast.error(fmtError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="border-2 border-dashed border-black/20 p-4 space-y-2" data-testid={`${kind}-autofill`}>
      <p className="text-xs font-bold uppercase tracking-widest text-black/60">Paste the link, we'll fill in the rest</p>
      <div className="flex gap-2">
        <Input data-testid={`${kind}-autofill-url`} value={url} onChange={(e) => setUrl(e.target.value)} placeholder={kind === "reel" ? "https://drive.google.com/… or Instagram / YouTube link" : "https://drive.google.com/… or https://medium.com/…"} />
        <button type="button" data-testid={`${kind}-autofill-btn`} onClick={run} disabled={busy} className="shrink-0 inline-flex items-center gap-2 px-4 py-2 bg-black text-white text-sm font-bold disabled:opacity-60">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />} {busy ? "Reading…" : "Auto-fill"}
        </button>
      </div>
      {busy && <p className="text-xs text-black/50">Reading the link and writing the copy, about 20 seconds.</p>}
    </div>
  );
}
